module.exports = __webpack_public_path__ + "static/media/app-screenshot-2.bc3ef7a3.webp";